// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SupportComponent} from './Support.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSupport = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SupportComponent/>
  </Icon>
));
